const Cardsdata = [
    {
    id: 1,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/144cafa8-fcfb-4e9a-8ec2-bd837694f99c_425x425.jpg",
    name: "NB REGULAR CHEESE PLATTER",
    category: "Breakfast",
    qty:1+"P",
    stprice: 3400,
    price: 999,

},
    {
    id: 2,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/01623b62-0190-483e-8d05-f260c3adc3cc_425x425.jpg",
    name: "NB ORGANIC CHEESE PLATTER",
    category: "CHEESE",
    qty:1+"P",
    stprice: 3400,
    price:2500 ,


},
    {
    id: 3,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/d73451d8-52ff-4fb3-962c-958342497dae_425x425.jpg",
    name: "NB SIGNATURE CHEESE PLATTER",
    category: "CHEESE",
    qty:1+"P",
    stprice: 3999,
    price:2500 ,


},
    {
    id: 4,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/dd045bf0-d98e-427c-8e9c-ad409d623023_425x425.jpg",
    name: "NB PREMIUM CHEESE PLATTER",
    category: "CHEESE",
    qty:1+"P",
    stprice: 7000,
    price:4999 ,


},
    {
    id: 5,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/b73229da-ff8a-4143-8d53-d548e60503ce_425x425.jpg",
    name: "NB CLASSY CHEESE PLATTER",
    category: "CHEESE",
    qty:1+"p",
    stprice: 1999,
    price:1499 ,


},
    {
    id: 6,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/ac84c7ad-d7fe-4cb9-8168-a3ac272e34b2_425x425.jpg",
    name: "NB ORGANIC CHEESE BOX 1",
    category: "CHEESE",
    qty:125+"g",
    stprice: 999,
    price:699 ,


},
    {
    id: 7,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/d6ca864a-55ea-4b36-b9c8-8b73b36b265b_425x425.jpg",
    name: "NB CHEESE BOX 3",
    category: "CHEESE",
    qty:125+"g",
    stprice: 699,
    price: 456,


},
    {
    id: 8,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/7c627b8b-e37d-4e28-9fd5-6e1f330cfe3f_425x425.jpg",
    name: "NB CHEESE IN A TRAY 1",
    category: "CHEESE",
    qty:125+"g",
    stprice: 769,
    price:565 ,


},
    {
    id: 9,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/28808ca7-cef1-4afd-884d-c243d46dac89_425x425.jpg",
    name: "MEAT PLATTER Turkey",
    category: "MEAT",
    qty:1+"P",
    stprice: 970,
    price:599 


},
    {
    id: 10,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/7b61bfac-51f8-4c25-8841-d37ff279299a_425x425.jpg",
    name: "MEAT PLATTER Chicken & Turkey, Pork..",
    category: "MEAT",
    qty:1+"P",
    stprice: 999,
    price:659 ,


},
    {
    id: 11,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/0a0f4359-ce08-40a7-88a5-c9bc8f7d12cb_425x425.jpg",
    name: "MEAT PLATTER Chicken & Turkey -",
    category: "MEAT",
    qty:1+"P",
    stprice: 1200,
    price:859 ,


},
    {
    id: 12,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/5ae688a3-5c64-467a-8e70-23db498cc4f8_425x425.jpg",
    name: "MEAT PLATTER Chicken - 399",
    category: "MEAT",
    qty:1+"P",
    stprice: 599,
    price:399 ,


},
    {
    id: 13,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/cf8d3565-855a-4c01-b8ea-2d8cdeee64ae_425x425.jpg",
    name: "MEAT PLATTER Chicken & Turkey -",
    category: "MEAT",
    qty:1+"P",
    stprice: 1599,
    price: 999,


},
    {
    id: 14,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/ecb76305-cf41-4ef5-b34f-f9969746ccb4_425x425.jpg",
    name: "MEAT PLATTER Chicken - 299",
    category: "MEAT",
    qty:1+"P",
    stprice: 569,
    price: 325,


},
    {
    id: 15,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/a0b9487f-e09f-48af-9908-d1d805cc66f5_425x425.jpg",
    name: "MEAT PLATTER Chicken, Turkey, Pork ..",
    category: "MEAT",
    qty:1+"P",
    stprice: 1999,
    price: 1499,


},
    {
    id: 16,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/2d775da9-bf34-40f2-a64a-f68d419cf2e6_425x425.jpg",
    name: "MEAT PLATTER Pork - 699",
    category: "MEAT",
    qty:1+"P",
    stprice: 3400,
    price: 757,


},
    {
    id: 18,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/f5f92a9d-0dd5-404d-a507-9d1d0233bdc2_425x425.jpg",
    name: "NB CHEESE BOX 2",
    category: "CHEESE",
    qty:125+"g",
    stprice: 3400,
    price: 490,


},
    {
    id: 19,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/fd3151a1-e840-45cf-98c6-2e9d6ea615da_425x425.jpg",
    name: "NB CHEESE BOX 5",
    category: "CHEESE",
    qty:125+"g",
    stprice: 3400,
    price:536 ,


},
    {
    id: 20,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/279191f7-4272-4e43-abfa-adc8893b38fc_425x425.jpg",
    name: "NB CHEESE BOX 3",
    category: "CHEESE",
    qty:125+"g",
    stprice: 3400,
    price: 345,


},
    {
    id: 21,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/279191f7-4272-4e43-abfa-adc8893b38fc_425x425.jpg",
    name: "NB CHEESE BOX 1",
    category: "CHEESE",
    qty:125+"g",
    stprice: 3400,
    price:457 ,


},
    {
    id: 22,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/71028fe6-eebc-4157-b198-497df1883a84_425x425.jpg",
    name: "NB CHEESE BOX 5",
    category: "CHEESE",
    qty:125+"g",
    stprice: 3400,
    price: 521,


},
{
    id: 23,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/d73451d8-52ff-4fb3-962c-958342497dae_425x425.jpg",
    name: "NB SIGNATURE CHEESE PLATTER",
    category: "CHEESE",
    qty:1+"P",
    stprice: 3400,
    price:2500 ,


},
{
    id: 24,
    image: "https://d1z88p83zuviay.cloudfront.net/ProductVariantThumbnailImages/b73229da-ff8a-4143-8d53-d548e60503ce_425x425.jpg",
    name: "NB CLASSY CHEESE PLATTER",
    category: "CHEESE",
    qty:1+"p",
    stprice: 3400,
    price:1499 ,


},
    
    
]
export default Cardsdata